import s from "~/pages/CameraZonesView/CameraZonesView.less";
import style from "../s.less";
import React, { createContext, useState } from "react";
import Modal from "~/shared/ui/Fields/Modal";
import IvideonPlayer from "~/components/IvideonPlayer/IvideonPlayer";

interface ICameraStatusUpdateContext {
  reFetchAllDependencyData: () => void;
}

export const CameraStatusUpdateContext =
  createContext<ICameraStatusUpdateContext>({
    reFetchAllDependencyData: () => {},
  });

export enum CAMERA_CHAT_MODE {
  HISTORY = "HISTORY",
  ACCEPT = "ACCEPT",
  CHAT = "CHAT",
}

interface CameraViewModalIProps {
  accessToken: string;
  apiHost: string;
  cameraId?: string;
  setOpenModal?: (boolean) => void;
  openModal?: boolean;
}

const CameraViewModal: React.FC<CameraViewModalIProps> = ({
  openModal,
  setOpenModal,
  cameraId,
  accessToken,
  apiHost,
}) => {
  const [player, setPlayer] = useState(null);

  const handleCloseModal = () => {
    player.destroy();
    setPlayer(null);
    setOpenModal(false);
  };

  return (
    <Modal
      isOpen={openModal}
      title={"Просмотр"}
      actionClose={handleCloseModal}
      customClassName={style.modal}
    >
      <div className={s.container}>
        <div className={s.subContainer}>
          <div className={style.playerWrapper}>
            <IvideonPlayer
              setPlayer={setPlayer}
              cameraId={cameraId}
              cameraName={""}
              apiHost={apiHost}
              accessToken={accessToken}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CameraViewModal;
